<template>
  <div class="contactus">
    <Header></Header>
    <div class="banner-img">
      <div class="flex-col container banner-title">
        <p class="main-title">数智化政企综合服务平台</p>
        <p class="sub-title">解决项目落地最后一公里</p>
      </div>
    </div>
    <div class="contactus-map container">
      <h1>联系我们</h1>
      <div class="map flex-row">
        <div class="left" id="containerMap">
          <!-- <div class="tip flex-col">
            <img src="@/assets/images/contactUs/company-logo.png" alt="">
            <img src="@/assets/images/contactUs/address-tip.png" alt="">
          </div> -->
        </div>
        <div class="right">
          <p class="tag">总部地址：</p>
          <p class="content">上海市浦东新区世博大道1368号世博源2区L1层</p>
          <p class="tag m-36">服务热线：</p>
          <p class="content">400-820-3779</p>
          <p class="tag m-36">联系电话：</p>
          <p class="content">021-58430856</p>
        </div>
      </div>
    </div>
    <div class="focus-us">
      <h1>关注我们</h1>
      <div class="flex-row list container">
        <div class="item flex-col">
          <img src="@/assets/images/contactUs/zc-qrcode.png" alt="">
          <span>中产集团</span>
        </div>
        <div class="item flex-col" style="margin:0 50px">
          <img src="@/assets/images/contactUs/xlh-qrcode.png" alt="">
          <span>星联会</span>
        </div>
        <div class="item flex-col" style="margin:0 20px">
          <img src="@/assets/images/contactUs/xdl-qrcode.png" alt="">
          <span>上海星动力科创空间</span>
        </div>
        <div class="item flex-col" style="margin:0">
          <img src="@/assets/images/contactUs/ky-qrcode.png" alt="">
          <span>上海浦东科苑培训中心</span>
        </div>
        <!-- <div class="item flex-col">
          <img src="@/assets/images/contactUs/wb-qrcode.png" alt="">
          <span>打开微博扫一扫</span>
        </div>
        <div class="item flex-col">
          <img src="@/assets/images/contactUs/dy-qrcode.png" alt="">
          <span>打开抖音扫一扫</span>
        </div> -->
      </div>

    </div>
    <div id="contact" class="communication">
      <h1>意向沟通</h1>
      <div class="form container">
        <el-form :model="form" ref="form" label-position="right" :inline="false" size="normal" label-width="150px">
          <el-form-item label="合作类型" required>
            <el-select v-model="form.demandType" placeholder="请选择" class="lw-w-500">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="需求描述" required>
            <el-input v-model="form.content" type="textarea" rows="3" resize="none" placeholder="请输入" class="lw-w-500" size="normal"></el-input>
          </el-form-item>
          <el-form-item label="联系人" required>
            <el-input v-model="form.contactName" placeholder="请输入" class="lw-w-500" size="normal"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" required>
            <el-input type="number" v-model="form.contactPhone" placeholder="请输入" class="lw-w-500" size="normal"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading='loading' @click="onSubmit">提交意向</el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import '@/assets/css/contactus.css'
import Header from './Header'
import Footer from './Footer'
export default {
  components: {
    Header, Footer
  },
  name: 'ContactUs',
  data () {
    return {
      logoSrc: require('@/assets/images/contactUs/company-logo.png'),
      pointSrc: require('@/assets/images/contactUs/address-tip.png'),
      form: {
        demandType: null,
        content: null,
        contactName: null,
        contactPhone: null
      },
      loading: false,
      options: [{
        value: '产业招商',
        label: '产业招商'
      }, {
        value: '企业选址',
        label: '企业选址'
      }, {
        value: '政企培训',
        label: '政企培训'
      }, {
        value: '咨询规划',
        label: '咨询规划'
      }, {
        value: '其他',
        label: '其他'
      }]
    }
  },

  mounted () {
    this.$nextTick(() => {
      const $map = window.BMapGL
      const map = new $map.Map('containerMap'); // 创建Map实例
      const point = new $map.Point(121.498758, 31.191931)

      // create point
      const myIcon = new window.BMapGL.Icon(this.pointSrc, new window.BMapGL.Size(20, 25));
      const pt = new window.BMapGL.Point(121.498758, 31.191931);
      const marker = new window.BMapGL.Marker(pt, { icon: myIcon });

      // company logo
      const mycompanyIcon = new window.BMapGL.Icon(this.logoSrc, new window.BMapGL.Size(200, 156));
      const companyPt = new window.BMapGL.Point(121.498794, 31.194697);
      const companyMarker = new window.BMapGL.Marker(companyPt, { icon: mycompanyIcon });

      // 将标注添加到地图
      map.addOverlay(marker);
      map.addOverlay(companyMarker);
      map.centerAndZoom(point, 16); // 初始化地图,设置中心点坐标和地图级别
      map.disableDoubleClickZoom();
    })
  },

  methods: {
    // 提交意向
    onSubmit () {
      const { demandType, content, contactName, contactPhone } = this.form
      if (!demandType || !content || !contactName || !contactPhone) return this.$message.error("请填写完整")
      this.loading = true
      this.Axios.post(`/api/index/cms/demand/save`, { ...this.form }).then(res => {
        this.loading = false
        this.$message.success("意向已提交")
        this.form = { demandType: null, content: null, contactName: null, contactPhone: null }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ContactUs.vue